var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result"},[_vm._v(" 暂未开发 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }